import { flexRender, HeaderGroup } from '@tanstack/react-table';
import { Icon } from '@uag/react-core';

import type { ArticleModel } from 'api/models';

import 'app/modules/wallforming/custom-styles/customCatalogueStyle.css';

interface CatalogueArticleTableHeaderProps {
    articleTableHeader: HeaderGroup<ArticleModel>[];
}

export const CatalogueArticleTableHeader = ({ articleTableHeader }: CatalogueArticleTableHeaderProps) => {
    return (
        <thead className="sticky top-0 z-10 shadow-[0_2px_2px_-1.5px_rgba(0,0,0,1)] bg-background-default">
            {articleTableHeader.map((headerGroup) => (
                <tr key={headerGroup.id} className="flex flex-nowrap justify-items-stretch w-full pl-[15px]">
                    {headerGroup.headers.map((header) => (
                        <th
                            key={header.id}
                            className="inline-block h-7 font-bold align-middle hover:bg-background-action-hover cursor-pointer"
                            title={
                                header.column.id === 'lifeCycleCode'
                                    ? 'Lifecycle'
                                    : header.column.id === 'articleNumber'
                                      ? 'Articlenumber'
                                      : undefined
                            }
                            onClick={(e) => {
                                const toggle = header.column.getToggleSortingHandler?.();
                                toggle?.(e);
                            }}
                        >
                            <div
                                className={`
                                    flex flex-row flex-nowrap justify-items-stretch
                                    ${header.column.id === 'lifeCycleCode' ? 'min-w-10' : 'min-w-20'}
                                `}
                            >
                                {flexRender(header.column.columnDef.header, header.getContext())}
                                <div className="flex justify-end justify-items-end w-full align-middle">
                                    <div className="flex justify-end justify-items-end align-middle">
                                        {header.column.getIsSorted() === 'asc' ? (
                                            <Icon className="bg-background-highlight rounded" icon="arrow_upward" />
                                        ) : header.column.getIsSorted() === 'desc' ? (
                                            <Icon className="bg-background-highlight rounded" icon="arrow_downward" />
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                </div>
                            </div>
                        </th>
                    ))}
                </tr>
            ))}
        </thead>
    );
};
